import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import history from '../../helpers/history';

import { Layout, PageHeader, Button, Input, Modal, Divider, Spin, message, Icon, List, Form, AutoComplete, Alert } from 'antd';

import OpenAISymbolGroupPage from '../../pannels/stock/OpenAISymbolGroupPage';
import StockOrderPage from '../../pannels/stock/StockOrderPage';
import OpenAIResultPage from '../../pannels/stock/OpenAIResultPage';

import emitter from '../Evt.js';

import '../../highlight-within-textarea.css';
import $ from 'jquery';
window.jQuery = $;
require('highlight-within-textarea');

const { Sider, Content } = Layout;

const TextArea = Input.TextArea;

var languageMessages = window.appLocale.messages;

function strReplace(source, jsonObjcet) {
    for (var v in jsonObjcet) {
        source = source.replace(v, jsonObjcet[v]);
    }
    return source;
}

const locale = window.appLocale.locale;

const ScanEmailForm = Form.create({ name: 'form_in_modal' })(
    class extends React.Component {
        state = {
            emailDataSource: [],
        };

        handleEmailChange = value => {
            this.setState({
                emailDataSource: !value || value.indexOf('@') >= 0 ? [] :
                    [`${value}@gmail.com`,
                    `${value}@outlook.com`,
                    `${value}@@hotmail.com`,
                    `${value}@yahoo.com`,
                    `${value}@ymail.com`,
                    `${value}@rocketmail.com`,
                    `${value}@zoho.com`,
                    `${value}@icloud.com`,
                    `${value}@me.com`,
                    `${value}@mac.com`,
                    `${value}@fastmail.com`,
                    `${value}@aol.com`,
                    `${value}@love.com`,
                    `${value}@ygm.com`,
                    `${value}@games.com`,
                    `${value}@wow.com`
                ],
            });
        };

        render() {
            const { naturalLanguage, formula, visible, onCancel, onCreate, isConfirmLoading, form } = this.props;
            const { getFieldDecorator } = form;

            const formItemLayout = {
                labelCol: {
                    xs: { span: 8 },
                    sm: { span: 4 },
                },
                wrapperCol: {
                    xs: { span: 16 },
                    sm: { span: 20 },
                },
            };

            let context = 'Idea:';
            context += '\n';
            context += naturalLanguage;
            context += '\n';
            context += '\n';
            context += 'formula:';
            context += '\n';
            context += formula;

            return (
                <Modal
                    title="Contact Us"
                    width={680}
                    visible={visible}
                    maskClosable={false}
                    confirmLoading={isConfirmLoading}
                    okText={'Send'}
                    onOk={onCreate}
                    onCancel={onCancel} >
                    <Form {...formItemLayout}>
                        <Form.Item label="Subject">
                            {getFieldDecorator('Subject', {
                                initialValue: 'idea to formula translation',
                                rules: [
                                    { required: true, min: 6, max: 100, message: 'Please input the email subject, with a length of 6-100' }
                                ],
                            })(<Input placeholder="idea to formula translation" />)}
                        </Form.Item>
                        <Form.Item label="Email">
                            {getFieldDecorator('Email', {
                                rules: [
                                    { type: 'email', message: 'The input is not valid Email', },
                                    { required: true, message: 'Please input the email address' }
                                ],
                            })(<AutoComplete
                                dataSource={this.state.emailDataSource}
                                onChange={this.handleEmailChange}
                                getPopupContainer={trigger => trigger.parentNode}
                                placeholder="Email address"
                            />)}
                        </Form.Item>
                        <Form.Item label="Content">
                            {getFieldDecorator('Content', {
                                initialValue: context,
                                rules: [{ required: true, message: 'Please input the email content' }],
                            })(<TextArea rows={6} />)}
                        </Form.Item>
                    </Form>
                </Modal>
            );
        }
    },
);

const SaveFilterForm = Form.create({ name: 'save_form_in_modal' })(
    class extends React.Component {

        render() {
            const { visible, onCancel, onCreate, isConfirmLoading, form } = this.props;
            const { getFieldDecorator } = form;

            const formItemLayout = {
                labelCol: {
                    xs: { span: 8 },
                    sm: { span: 4 },
                },
                wrapperCol: {
                    xs: { span: 16 },
                    sm: { span: 20 },
                },
            };

            return (
                <Modal
                    //title="Save Script"
                    closable={false}
                    visible={visible}
                    maskClosable={false}
                    confirmLoading={isConfirmLoading}
                    okText={'Save'}
                    onOk={onCreate}
                    onCancel={onCancel} >
                    <Form {...formItemLayout}>
                        <Form.Item label="Name">
                            {getFieldDecorator('Name', {
                                rules: [{ required: true, message: 'Please input the name' }],
                            })(<TextArea rows={4} />)}
                        </Form.Item>
                    </Form>
                </Modal>
            );
        }
    },
);

class ScanPage extends Component {
    constructor(props) {
        super(props);

        let tmpStockGroups = window.webType === 'US' ? '10401' : '3180';

        let tmpOrderType = '$VOLUME_NUM';
        let tmpOrderDirection = '0';

        /**
        var cacheFilterString = JSON.parse(sessionStorage.getItem("cacheScanCondition") || '{}') || {};
        if (Object.keys(cacheFilterString).length > 0) {
            tmpFilterString = cacheFilterString['filterString'];
            tmpStockPoolKey = cacheFilterString['stockPoolKey'];
            tmpStockGroups = cacheFilterString['stockGroups'];

            tmpOrderType = cacheFilterString['orderType'];
            tmpOrderDirection = cacheFilterString['orderDirection'];

            sessionStorage.removeItem("cacheScanCondition");
        }
        */

        let tmpWebOpenWith = window.performance.navigation.type;

        //var referrerUrl = document.referrer;
        var referrerUrl = "https://chat.openai.com";

        // 要检查是否包含的子字符串
        const searchString = "https://chat.openai.com";
        
        var tmpFormulaName = '';
        var tmpFilterString = '';
        var tmpUseFormula = '';

        var baseFormulaName = '';
        var baseFormulaString = '';

        // 使用 includes 方法检查
        if (referrerUrl.includes(searchString)) {
            const searchParams = new URLSearchParams(window.location.search);
            baseFormulaName = searchParams.get("L");
            var paramsFormulaName = baseFormulaName;
            if (paramsFormulaName) {
                paramsFormulaName = paramsFormulaName.replace(/\s/g, '+');
                //paramsFormulaName = btoa(paramsFormulaName);
                console.log(paramsFormulaName);
                try {
                    var tmpParamsFormulaName = '';
                    paramsFormulaName = atob(paramsFormulaName);
                    console.log('paramsFormulaName', paramsFormulaName);
                    //console.log(JSON.stringify(paramsFormulaName));
                    var items = paramsFormulaName.split('\n');
                    for (var item in items) {
                        if (items[item] != '') {
                            if (tmpParamsFormulaName != '') tmpParamsFormulaName += '\n';
                            tmpParamsFormulaName += items[item];
                        }
                    }
                    paramsFormulaName = tmpParamsFormulaName;
                } catch (error) {
                    console.error("Error in decoding: ", error.message);
                }
            }

            baseFormulaString = searchParams.get("C");
            var paramsFormulaString = baseFormulaString;
            if (paramsFormulaString) {
                paramsFormulaString = decodeURIComponent(paramsFormulaString);
                paramsFormulaString = paramsFormulaString.replace(/[\s\u200B]+$/g, '');
                console.log('paramsFormulaString', paramsFormulaString);

                paramsFormulaString = paramsFormulaString.trim();
                baseFormulaString = paramsFormulaString;

                paramsFormulaString = paramsFormulaString.replace(/\s/g, '+');

                try {
                    paramsFormulaString = atob(paramsFormulaString);
                    tmpUseFormula = this.formatHtml(paramsFormulaString);
                } catch (error) {
                    console.error("Error in decoding: ", error.message);

                    //paramsFormulaString = encodeURIComponent(paramsFormulaString).replace(/%([0-9A-F]{2})/g, function (match, p1) {
                    //    return String.fromCharCode('0x' + p1);
                    //});
                    //paramsFormulaString = atob(paramsFormulaString);
                    //tmpUseFormula = this.formatHtml(paramsFormulaString);
                }
            }

            tmpFormulaName = paramsFormulaName == null ? '' : paramsFormulaName;
            tmpFilterString = paramsFormulaString == null ? '' : paramsFormulaString;
        }
        
        this.user = {};
        this.state = {
            stockPoolKey: 'STOCK',

            stockGroups: tmpStockGroups,
            stockGroupName: languageMessages['sp.500'],
            
            formulaName: tmpFormulaName,
            filterString: tmpFilterString,
            useFormula: tmpUseFormula,

            orderType: tmpOrderType,
            orderDirection: tmpOrderDirection,
            isUseOrder: false,
            
            stockCount: 0,

            scanAlert: null,

            scanRequestLoadding: false,
            isShowStockResultPage: false,

            spinLoadding: true,

            isLuis: true,

            error: '',

            stockGroupLoadding: false,
            isStockGroupDone: false,

            ideaItems: [],

            messageVisible: false,
            isConfirmLoading: false,

            name: '',
            saveRequestLoadding: false,
            
            alertMessage: '',

            nameVisible: false,

            currSelFilterId: 0,

            webOpenWith: tmpWebOpenWith,
            baseFormulaName: baseFormulaName,
            baseFormulaString: baseFormulaString,
        };
    }

    formatHtml(formatString) {
        if (formatString === null || formatString === undefined || formatString === '') return '';

        var formatStrings = [];
        var items = formatString.split('\n');
        for (var item in items) {
            if (items[item] != '') {
                const trimmedLine = items[item].trim();
                if (trimmedLine.startsWith('//')) continue;

                if (formatStrings.length > 0) formatStrings.push(<br key={item} />);
                formatStrings.push(trimmedLine);
            }
        }

        return formatStrings;
    }

    componentDidMount() {
        emitter.addListener('initPage', this.init);
        emitter.addListener("callSendError", this.callSendError);
        emitter.addListener('callFilterRequestResult', this.callFilterRequestResult);

        emitter.addListener("callScanResult", this.callScanResult);

        emitter.addListener('callCustomSymbolGroups', this.callCustomSymbolGroups);

        emitter.addListener('callScanIntervalResult', this.callScanIntervalResult);
    }

    componentWillMount() {
        this.init();
    }

    componentWillUnmount() {
        emitter.removeListener('initPage', this.init);
        emitter.removeListener('callSendError', this.callSendError);
        emitter.removeListener('callFilterRequestResult', this.callFilterRequestResult);

        emitter.removeListener('callScanResult', this.callScanResult);

        emitter.removeListener('callCustomSymbolGroups', this.callCustomSymbolGroups);

        emitter.removeListener('callScanIntervalResult', this.callScanIntervalResult);
    }

    callFilterRequestResult = (filterResult, filter) => {
        if (filterResult.Status === 0) {
            message.error(filterResult.Description);
            //this.setState({ alertMessage: '' });
        } else {
            message.error(filterResult.Description);

            this.setState({ spinLoadding: false, scanRequestLoadding: false, stockGroupLoadding: false, isStockGroupDone: false, alertMessage: <Alert message={filterResult.Description} type="error" showIcon /> });
        }
    }

    callScanIntervalResult = (date) => {
        message.warning('Next scan after ' + date);
        this.setState({ spinLoadding: false, scanRequestLoadding: false, stockGroupLoadding: false, isStockGroupDone: false, alertMessage: <Alert message={'Next scan after ' + date} type="warning" showIcon /> });
    }

    callSendError = (status) => {
        this.setState({ spinLoadding: false, scanRequestLoadding: false, stockGroupLoadding: false, isStockGroupDone: false });
    }

    callCustomSymbolGroups = (symbolGroup) => {
        let { isStockGroupDone } = this.state;

        if (symbolGroup.Status === 0) {
            var customStockGroupsCache = JSON.parse(sessionStorage.getItem("CustomStockGroupsCache") || '[]') || [];
            if (customStockGroupsCache.length > 0) {
                const index = customStockGroupsCache.findIndex(item => item.groupId === symbolGroup.gi);
                if (index > -1) {
                    customStockGroupsCache[index].groupName = symbolGroup.gn;
                    customStockGroupsCache[index].symbolList = symbolGroup.sg;
                } else {
                    customStockGroupsCache.push({ groupId: symbolGroup.gi, userId: symbolGroup.ui, groupName: symbolGroup.gn, symbolList: symbolGroup.sg });
                }
            } else {
                customStockGroupsCache.push({ groupId: symbolGroup.gi, userId: symbolGroup.ui, groupName: symbolGroup.gn, symbolList: symbolGroup.sg });
            }
            sessionStorage.setItem("CustomStockGroupsCache", JSON.stringify(customStockGroupsCache));

            isStockGroupDone = true;

            var content = <span>{strReplace(languageMessages['already.add.success'], { '{num}': this.state.stockCount })}，<a href="javascript:;" onClick={this.jumpMyCustomStock}>{languageMessages['view.my.self-selected.stock']}</a></span>;
            this.timerModal(languageMessages['self-selected.stock.added.success'], content);
        } else {
            isStockGroupDone = false;
            message.error(symbolGroup.Description);
        }

        this.setState({ stockGroupLoadding: false, isStockGroupDone });
    }

    callScanResult = (scanAlert) => {
        if (scanAlert.hasOwnProperty('count') > 0 && scanAlert['count'] > 0) {
            this.setState({
                scanRequestLoadding: false,
                scanAlert: scanAlert,
                isShowStockResultPage: true,
                alertMessage: ''
            });
        } else {
            this.setState({
                scanRequestLoadding: false,
                alertMessage: <Alert message={languageMessages['no.choice.to.stock']} type="info" showIcon />
            });
            
            message.info(languageMessages['no.choice.to.stock']);
        }
    }

    init = () => {
        this.user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};

        this.props.dispatch({
            type: "action_get_scan_sectors",
            payload: {
                u: this.user.username,
                sp: this.state.stockPoolKey,
                sg: this.state.stockGroups,
                wow: this.state.webOpenWith,
                bfn: this.state.baseFormulaName,
                bfs: this.state.baseFormulaString,
                fn: this.state.formulaName,
                fs: this.state.filterString,
            }
        });
    }

    componentDidUpdate() {
    }

    componentWillReceiveProps(props) {
        var { status, state, naturalLangFormulas, customGroup, id } = props;
        
        switch (status) {
            case 'scan_sectors_success':
                var ideaItems = [];
                if (naturalLangFormulas.length > 0) {
                    for (var item in naturalLangFormulas) {
                        ideaItems.push({ 'id': naturalLangFormulas[item].id, 'name': naturalLangFormulas[item].name, 'naturalLanguage': naturalLangFormulas[item].naturalLanguage, 'formulas': naturalLangFormulas[item].formulas });
                    }
                }

                this.setState({ ideaItems, spinLoadding: false, webOpenWith: 1 });
                break;
            case 'scan_sectors_fail':
                var error = languageMessages['get.data.failed'];
                switch (state) {
                    case 0:
                        break;
                    case 2:
                        error = languageMessages['user.exception'];
                        break;
                    default:
                        break;
                }
                message.error(error);
                this.setState({ spinLoadding: false });
                break;
            case 'update_customStock_success':
                var customStockGroups = JSON.parse(sessionStorage.getItem("CustomStockGroupsCache") || '[]') || [];
                if (customStockGroups.length > 0) {
                    const index = customStockGroups.findIndex(item => item.groupId === customGroup.groupId);
                    if (index > -1) {
                        customStockGroups[index].groupName = customGroup.groupName;
                        customStockGroups[index].symbolList = customGroup.symbolList;
                    } else {
                        customStockGroups.push(customGroup);
                    }
                } else {
                    customStockGroups.push(customGroup);
                }
                sessionStorage.setItem("CustomStockGroupsCache", JSON.stringify(customStockGroups));

                var content = <span>{strReplace(languageMessages['already.add.success'], { '{num}': this.state.stockCount })}，<a href="javascript:;" onClick={this.jumpMyCustomStock}>{languageMessages['view.my.self-selected.stock']}</a></span>;
                this.timerModal(languageMessages['self-selected.stock.added.success'], content);
                break;
            case 'update_customStock_fail':
                var error = languageMessages['joining.stock.pool.failed'];
                switch (state) {
                    case 0:
                        break;
                    case 2:
                        error = languageMessages['user.exception'];
                        break;
                    default:
                        break;
                }
                message.error(error);
                break;
            case 'get_stock_count_success':
                this.setState({
                    //stockGroups: data.stockGroups,
                    //stockPoolKey: data.stockPoolKey,
                    error: '',
                });
                break;
            case 'get_stock_count_fail':
                this.setState({
                    error: '',
                });
                break;
            case 'gpts_message_success':
                let { ideaItems, name, formulaName, filterString } = this.state;

                ideaItems.unshift({ 'id': id, 'name': name, 'naturalLanguage': formulaName, 'formulas': filterString });
                
                this.formRef.props.form.resetFields();

                this.setState({ ideaItems, currSelFilterId: id, nameVisible: false, saveRequestLoadding: false });

                message.success('Save success');
                break;
            case 'gpts_message_fail':
                this.setState({ saveRequestLoadding: false });
                break;
            case 'send_email_success':
                this.scanform.props.form.resetFields();

                this.setState({
                    messageVisible: false,
                    isConfirmLoading: false
                });

                message.success('Send success');
                break;
            case 'send_email_fail':
                this.setState({
                    isConfirmLoading: false,
                });
                message.error('Send fail');
                break;
            default:
                break;
        }
    }

    timerModal(title, content) {
        let secondsToGo = 5;
        const modal = Modal.success({
            title: title,
            content: content,
        });

        setTimeout(() => {
            modal.destroy();
        }, secondsToGo * 1000);
    }

    toggleLuisStockPicker = () => {
        var { isLuis } = this.state;
        isLuis = isLuis ? false : true;
        this.setState({ isLuis });
    }

    handleStockGroup(data) {
        this.setState({
            stockGroups: data.stockGroups,
            stockPoolKey: data.stockPoolKey,
            stockGroupName: data.stockGroupName
        }, () => {
            /**
            if (user.username === undefined) {
                this.setState({ spinLoadding: false }, () => {
                    this.props.dispatch({ type: "action_non_user" });
                });
            } else {
                this.props.dispatch({ type: "action_get_stock_count", payload: { UserId: user.username, stockPoolKey: data.stockPoolKey, stockGroups: data.stockGroups } });
            }
            */
            this.props.dispatch({ type: "action_get_stock_count", payload: { UserId: this.user.username, stockPoolKey: data.stockPoolKey, stockGroups: data.stockGroups } });
        });
    }

    handleCustomStock(data) {
        if (this.user.username === undefined) {
            this.props.dispatch({ type: "action_non_user" });
        } else {
            this.setState({
                stockGroupLoadding: true,
                isStockGroupDone: false,
                stockCount: data.StockCount
            }, () => {

                var action = 'new';
                // 更新股票池
                if (data.GroupId > 0) {
                    action = 'update';
                    //this.props.dispatch({ type: "action_update_formula_custom_stock", payload: { GroupId: data.GroupId, UserId: this.user.username, GroupName: data.GroupName, SymbolList: data.SymbolList } });
                } else {
                    //this.props.dispatch({ type: "action_add_formula_custom_stock", payload: { UserId: this.user.username, GroupName: data.GroupName, SymbolList: data.SymbolList } });
                }

                this.props.dispatch({
                    type: "action_send_hub_message", payload: {
                        service: 'SendCustomSymbolGroups', userId: this.user.username,
                        msg: {
                            Action: action,
                            GroupId: data.GroupId,
                            UserId: this.user.username,
                            GroupName: data.GroupName,
                            OldGroupName: data.GroupName,
                            SymbolList: data.SymbolList
                        }
                    }
                });
            });
        }
    }

    jumpMyCustomStock = e => {
        e.preventDefault();

        Modal.destroyAll();

        emitter.emit('callJump', 'customStock');
        history.push("/customStock");
    }

    handleStockOrder(data) {
        this.setState({
            orderType: data.orderType,
            orderDirection: data.orderDirection,
            isUseOrder: data.isUseOrder,
        });
    }

    startScanFilter = () => {
        if (this.user.username === undefined) {
            //saved to cache
            /**
            let tmpScanCondition = {
                filterString: this.state.filterString,
                stockPoolKey: this.state.stockPoolKey,
                stockGroups: this.state.stockGroups,
                orderType: this.state.orderType,
                orderDirection: this.state.orderDirection
            };

            //sessionStorage.setItem("cacheScanCondition", JSON.stringify(tmpScanCondition));
            */
            this.props.dispatch({ type: "action_non_user" });
        } else {
            var { stockGroups,
                stockPoolKey,
                formulaName,
                filterString,
                orderType,
                orderDirection,
                isUseOrder } = this.state;

            if (stockGroups === '') {
                this.setState({
                    error: 'STOCK_GROUP_ERROR',
                });
                return;
            }

            if (filterString.length > 8000) {
                message.error(languageMessages['strategy.content.length.too.long']);
                return;
            }

            window._hmt && window._hmt.push(['_trackEvent', 'Formula scan', 'scan', 'Vernacular Formula scan']);

            this.setState({ isShowStockResultPage: false, scanRequestLoadding: true, alertMessage: '' }, () => {
                this.props.dispatch({
                    type: "action_send_hub_message", payload: {
                        service: 'SendScanFilter', userId: this.user.username,
                        msg: {
                            Category: 'scan',
                            Action: 'scan',
                            UserId: this.user.username,
                            FilterId: 0,
                            FilterName: '',
                            GroupType: stockPoolKey,
                            FilterString: filterString,
                            SymbolGroupId: stockGroups,
                            OrderType: isUseOrder ? '' : orderType,
                            OrderDirection: isUseOrder ? '' : orderDirection
                        }
                    }
                });
            });
        }
    };

    openFilter = () => {
        this.setState({ nameVisible: true, saveRequestLoadding: false });
    };

    handleNameCancel = () => {
        this.setState({ nameVisible: false, saveRequestLoadding: false });
    }

    saveFilter = () => {
        const { form } = this.formRef.props;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }

            if (this.user.username === undefined) {
                this.props.dispatch({ type: "action_non_user" });
            } else {
                var { formulaName, filterString } = this.state;

                this.setState({ name: values["Name"], saveRequestLoadding: true }, () => {
                    this.props.dispatch({
                        type: "action_set_gpts_chat_message",
                        payload: {
                            u: this.user.username,
                            n: values["Name"],
                            l: formulaName,
                            f: filterString
                        }
                    });
                });
            }
        });
    };

    showModal = () => {
        this.setState({ messageVisible: true });
    };

    handleModalCancel = () => {
        this.setState({ messageVisible: false });
    };

    saveFormRef = formRef => {
        this.formRef = formRef;
    };

    scanFormRef = formRef => {
        this.scanform = formRef;
    };
    
    sendEmail = () => {
        const { form } = this.scanform.props;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }

            if (this.user.username === undefined) {
                this.props.dispatch({ type: "action_non_user" });
            } else {
                this.setState({ isConfirmLoading: true }, () => {

                    var emailBody = values["Content"];
                    emailBody = emailBody.replace(/\n/g, "<br />");

                    this.props.dispatch({
                        type: "action_send_email",
                        payload: {
                            u: this.user.username,
                            s: values["Subject"],
                            e: values["Email"],
                            c: emailBody
                        }
                    });

                });
            }
        });
    };

    handleSelFiter = (id) => {
        let { ideaItems } = this.state;

        var ideas = ideaItems.filter(function (e) { return e.id == id });
        if (ideas.length > 0) {
            var idea = ideas[0];
            this.setState({
                currSelFilterId: id,
                formulaName: idea.naturalLanguage,
                filterString: idea.formulas,
                useFormula: this.formatHtml(idea.formulas),
            });
        }
        
    };

    render() {
        var { stockPoolKey, stockGroupName, filterString, useFormula, formulaName, stockGroups, ideaItems, scanAlert, messageVisible, isConfirmLoading, nameVisible, saveRequestLoadding, alertMessage } = this.state;
        var { sectors, stockCount } = this.props;

        var defaultSymbolGroups = {
            stockPoolKey: stockPoolKey,
            stockGroups: stockGroups,
            sectors: sectors,
            stockCount: stockCount,
        }

        let textareaPlaceholder = languageMessages['vernacular.left.prompt'];

        let statement = languageMessages['input.stock.picking.statement'];
        if (window.webType === 'US') {
            let aryStatement = [];
            let tmpStatement = statement.replace('Highlighted', ',');
            let tmpStatements = tmpStatement.split(',');
            for (let i = 0; i <= tmpStatements.length; i++) {
                if (i === 1) {
                    aryStatement.push(<span key={'statement' + i} className='common-bg'>Highlighted</span>)
                }
                aryStatement.push(tmpStatements[i]);
            }

            statement = aryStatement;

            var val = 'type your complete idea, e.g. "#val".';
            textareaPlaceholder = 'Type key word, e.g. "Bollinger band", then select from ideas in left panel, or';
            textareaPlaceholder += String.fromCharCode(10);
            textareaPlaceholder += val.replace('#val', 'Price makes 50 day high');
            textareaPlaceholder += String.fromCharCode(10);
            textareaPlaceholder += 'Scan the market.Have fun learning.';
        }

        return (<Content className='main-container total-content'>
            <Helmet>
                <title>{languageMessages['vernacular title']}</title>
                <meta name="keywords" content={languageMessages['vernacular keywords']} />
                <meta name="description" content={languageMessages['vernacular description']} />

                <meta property="og:title" content={languageMessages['vernacular title']} />
                <meta property="og:url" content="https://us.quancept.com/" />
                <meta property="og:type" content="website" />
                <meta name="og:description" content={languageMessages['vernacular description']} />

                <meta property="twitter:url" content="https://us.quancept.com/" />
                <meta name="twitter:title" content={languageMessages['vernacular title']} />
                <meta name="twitter:description" content={languageMessages['vernacular description']} />
                <meta name="twitter:site" content="https://us.quancept.com/" />
            </Helmet>
            <Spin spinning={this.state.spinLoadding}>
            <div className='common-page-header'>
                <PageHeader title={(<h1>{'AI ScreenBot'}</h1>)} subTitle={'(Free beta, limited time only)'} />
            </div>
            <Layout className='scan-content luis-main-content'>
                <OpenAISymbolGroupPage defaultSymbolGroups={defaultSymbolGroups} stockGroup={this.handleStockGroup.bind(this)} error={this.state.error} />

                <div className='common-title'>
                    <Divider type="vertical" />
                    <span style={{ cursor: 'pointer' }} onClick={this.toggleLuisStockPicker}>
                        {languageMessages['vernacular.stock.picking']}
                        <Icon type={this.state.isLuis ? 'up' : 'down'} style={{ padding: '0 5px' }} />
                    </span>
                </div>
                <div style={{ display: this.state.isLuis ? '' : 'none' }}>
                    <Layout className={window.webType === 'US' ? 'luis luis-us' : 'luis'}>
                        <Sider width={360}>
                            <List size={"small"}
                                dataSource={ideaItems}
                                pagination={ideaItems.length < 10 ? false : {
                                    size: "small",
                                    pageSize: 10,
                                }}
                                renderItem={item => (
                                    <List.Item key={item.id} onClick={() => this.handleSelFiter(item.id)} className={this.state.currSelFilterId === item.id ? 'checked' : ''}>
                                        <span title={item.name} className="list-item-span">{item.name}</span>
                                    </List.Item>
                                )}
                            />

                        </Sider>
                        <Layout className='luis-content'>
                            <h2 style={{ padding: '10px 5px', marginBottom: 5, fontWeight: 'normal' }}>{'Idea'}</h2>
                            <TextArea className="luis-highlight-textarea" placeholder={textareaPlaceholder} rows={4} value={formulaName} />

                            <h2 style={{ padding: '10px 5px', marginBottom: 5, fontWeight: 'normal' }}>{languageMessages['correspond.formula']}</h2>
                            <div className='common-edit' style={{ height: '120px' }}>{useFormula}</div>
                            <StockOrderPage filterString={filterString} isUseOrder={this.state.isUseOrder} stockOrder={this.handleStockOrder.bind(this)} />
                            <div style={{ padding: '10px 0' }}>
                                <div style={{ float: "left" }}>
                                    <Button size='small' onClick={this.startScanFilter} loading={this.state.scanRequestLoadding} disabled={this.props.scanRequestLoadding || filterString === ''}>
                                        {'Scan'}
                                    </Button>
                                    <span style={{ width: 10, display: 'inline-block' }}></span>
                                    <Button size='small' onClick={this.openFilter} disabled={filterString === ''}>{'Save'}</Button>
                                    <SaveFilterForm
                                        wrappedComponentRef={this.saveFormRef}
                                        visible={nameVisible}
                                        onCancel={this.handleNameCancel}
                                        onCreate={this.saveFilter}
                                        isConfirmLoading={saveRequestLoadding}
                                        />
                                        <span style={{ marginLeft: '10px', display: 'inline-block' }}>{alertMessage}</span>
                                </div>
                                <div style={{ float: "right" }}>
                                    <Button type="primary" onClick={() => this.showModal()}>Support</Button>
                                    <ScanEmailForm
                                        wrappedComponentRef={this.scanFormRef}
                                        naturalLanguage={formulaName}
                                        formula={filterString}
                                        visible={messageVisible}
                                        onCancel={this.handleModalCancel}
                                        onCreate={this.sendEmail}
                                        isConfirmLoading={isConfirmLoading}
                                    />
                                </div>
                            </div>
                        </Layout>
                    </Layout>
                </div>
            </Layout>
            
            {this.state.isShowStockResultPage && (<div>
            <div className='common-separate-block'></div>
            <Content className='scan-content'>
                <OpenAIResultPage isStockGroupDone={this.state.isStockGroupDone}
                    stockGroupLoadding={this.state.stockGroupLoadding}
                    stockPoolKey={stockPoolKey}
                    stockGroupName={stockGroupName}
                    scanAlert={scanAlert}
                    customStockEvent={this.handleCustomStock.bind(this)} />
            </Content></div>)}
        </Spin>
    </Content>);
    }
}

function mapStateToProps(state) {
    return state.vernacular;
}

const page = connect(mapStateToProps)(ScanPage);
export { page as default }